import React, { useState, useEffect } from 'react';
import api from '../../Services/api';
import { COLORS } from '../colors';
import '../EditableCard.css'
import { Snackbar, Button,Menu, MenuItem, Select, FormControl, InputLabel,TextField} from '@mui/material';
import SnackbarContent from '@mui/material/SnackbarContent';
import { MdFileOpen, MdRemoveRedEye, MdDelete, MdEditDocument } from "react-icons/md";
import ClientMonthlyReport from '../Client/ClientMonthlyReport';
import { useLocation } from 'react-router-dom';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

 import { FaFileDownload } from "react-icons/fa";
import { Category } from '@mui/icons-material';

const hardcodedDueDates = {
  "AccidentalReportSubmission": "Every Month before 5th",
  "TheGoodsAndServiceTaxOutwardSupplies": "Every Month before 11th",
  "TheGoodsAndServiceTaxSummaryReturn": "Every Month Before 20th",
  "EsicMonthlyContributionHistoryAndChallans": "Every Month Before 15th",
  "EpfoEcrAndRemittanceConfirmationChallan": "Every Month Before 15th",
  "EpfoPaidChallanCopyAndDate": "Every Month Before 15th",
  "EpfoCopyOfReturnToInternationalWorkers": "Every Month Before 20th",
  "LabourWelfareFund": "Every Month Before 5th",
  "TaxOnProfessions": "Every Month Before 5th",

  "FactoryHalfYearReturn": "Before 31st July",
  "PressureVesselReport": "Every Six Months",
  "FireSafetyTraining": "Every Six Months",
  "EsicHalfYearlyReturnsMaintainHalfYearlyReturn":"Half Yearly",
  "FactoryAnnualReturns": "Before 31st January",
  "HazardousWasteAnnualReturns": "30th June",
  "EnvironmentalAuditReport": "31st March",
  "LabourWelfareFundFormD": "Before 15th & 31st January",
  "ClraRcAnnualReturns": "Before 31st January",
  "PaymentOfBonusActReturnAnnexure": "Before 31st December",
  "PaymentOfBonusActReturnAcknowledgementCopy":'Before 31st December'
};

const titles = [
  "TheGoodsAndServiceTaxOutwardSupplies",
  "TheGoodsAndServiceTaxSummaryReturn",
  "FactoryHalfYearReturn",
  "FactoryAnnualReturns",
  "FireSafetyTraining",
  "EnvironmentalAuditReport",
  "DirectGreenhouseGasGHGEmissions",
  "IndirectGHGEmissions",
  "AllOtherIndirectEmissionsInTheValueChain",
  "TotalEnergyConsumedRenewableSources",
  "TotalEnergyConsumedNonRenewableSources",
  "WaterConsumed",
  "TotalAmountOfwasteGenerated",
  "CapExOnGreenInitiatives",
  "PenaltiesAndFinesPaidDueToEnvironmentalIssues",
  "OpexOnGreenInitiatives",
  "CSRBudgetAsAPercentOfProfits",
  "PercentOfCSRBudgetUtilized",
  "HazardousWasteAnnualReturns",
  "PressureVesselReport",
  "EpfoEcrAndRemittanceConfirmationChallan",
  "EpfoPaidChallanCopyAndDate",
  "EpfoCopyOfReturnToInternationalWorkers",
  "EsicMonthlyContributionHistoryAndChallans",
  "EsicHalfYearlyReturnsMaintainHalfYearlyReturn",
  "TaxOnProfessions",
  "LabourWelfareFund",
  "LabourWelfareFundFormD",
  "ClraRcAnnualReturns",
  "PaymentOfBonusActReturnAnnexure",
  "PaymentOfBonusActReturnAcknowledgementCopy",
  "EmployeeTurnoverRate",
  "AverageHoursOfTrainingPerEmployee",
  "GenderPayGap",
  "WorkforceDemographics",
  "PercentageOfIndependentDirectorsOnTheBoard",
  "BoardDiversity",
  "TotalEmployeeCompensationAndBenefits",
  "TotalExpenditureOnEmployeeTraining",
  "CapexOnEmployeeWelfareInitiatives",
  "AnnualReturnsPOSHAct2013",
  "PendingCasesPOSHAct2013",
  "AccidentReportSubmission",
  "PendingNoticeFromGovtBodies",
  "NetZeroTarget",
  "WomenInWorkforce",
  "NumberOfWomenDirectorsOnTheBoard",
  "ShareholdersComplaintsResolved",
  "WhistleblowerComplaintsResolved",
  "TotalRecordableIncidentRate",
  "AnnualGeneralBodyMeeting",
  "BoardMeetings",
  "ReviewByAuditCommittee",
  "PercentageOfEmployeessignedCOBEC",
  "BoardReviewOfESGPerformance",
  "CSRProjectsCompletedAndOngoing",
  "ReviewByRiskCommittee",

];



const formatTitle = (title) => {
  return title.replace(/([a-z])([A-Z])/g, '$1 $2');
};

const months = [
    { name: "JANUARY", value: "01" },
    { name: "FEBRUARY", value: "02" },
    { name: "MARCH", value: "03" },
    { name: "APRIL", value: "04" },
    { name: "MAY", value: "05" },
    { name: "JUNE", value: "06" },
    { name: "JULY", value: "07" },
    { name: "AUGUST", value: "08" },
    { name: "SEPTEMBER", value: "09" },
    { name: "OCTOBER", value: "10" },
    { name: "NOVEMBER", value: "11" },
    { name: "DECEMBER", value: "12" }
];

const currentYear = new Date().getFullYear();

const years = Array.from({ length: currentYear - 2020 + 1 }, (x, i) => 2020 + i);




   

    
const MonthlydataEstablishment = () => {
   const location = useLocation();

     const[loading,setLoading]=useState(true);
     const [assessorFormData, setAssessorFormData] = useState({
        assessorCompanyName: '',
        assessorId: '',
        companyId:''
      });
      
        const [clients, setClients] = useState([]);
      const[locationFilter,setLocationFilter] =  useState('')
        const [companyId,setCompanyId] = useState("");
          const [complianceFiledDate, setComplianceFiledDate] = useState('')
        const [userType, setUserType] = useState('');
        const [establishment, setEstablishment] = useState([]);
        const [showModal, setShowModal] = useState(false);
    const [saveStates, setSaveStates] = useState({});
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
    const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
  const [uploadStates, setUploadStates] = useState({});
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState('');
   const handleShow = () => setShowModal(true); 
   const handleClose = () => setShowModal(false);
  const [openedDocs, setOpenedDocs] = useState({});
const [pendingValidation, setPendingValidation] = useState({});
 const [clientFormData, setClientFormData] = useState({
    clientName: '',
    companyId: '',
    principleEmployer: '',
    companyAddress: '',
    placeName: '',
    clientContactPersonName: '',
    clientContactPersonEmailId: '',
    clientContactPersonPhoneNumber: '',
    stateId: ''
  });
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [activeRemarkIndex, setActiveRemarkIndex] = useState(null);
  const [editableRemarks, setEditableRemarks] = useState({}); 
  const suggestionOptions = ["Verified Ok", "InComplete", "Wrong document", "OverDue", "Other"];
  const [menuOptions, setMenuOptions] = useState(suggestionOptions);

  
useEffect(()=>{
    const timer = setTimeout(()=>{
        setLoading(false)
    },600)
    return () => clearTimeout(timer)
},[])

 useEffect(() => {
      const sessionData = sessionStorage.getItem('user');
      const parsed = JSON.parse(sessionData);
      const id = parsed.id;
      const type = parsed.type;
    
      setUserType(type); // optional, only if you're using it elsewhere
    
      // First get assessor details
      if(type ==='assessor'){
      api.assessor.findOne(id)
        .then(response => {
          const assessorInfo = response.data.data;
          const companyIdFromAssessor = assessorInfo.companyId;
          setAssessorFormData(assessorInfo);
          setCompanyId(companyIdFromAssessor);
          sessionStorage.setItem('selectedCompanyId',companyIdFromAssessor)// set this first
          if(companyIdFromAssessor){
          fetchEstablishment(assessorInfo.companyId); 
          }
          else{
            setErrorSnackbarOpen(true)
            setSnackbarErrorMessage("Fetching data failed, please try again later")
          }// call with the correct companyId
    
        })
        .catch(error => {
          console.error('Error fetching company data:', error);
          setLoading(false);
        });
    } 
    else if (type === 'admin') {
      fetchClient();
    }
    }, [userType]); 
  
const fetchClient = async () => {
    try {
      const response = await api.client.getClients();

      if (response.status === 200) {

        setClients(response.data);
        setLoading(false)
      }
      else {
        setClients([])
        setLoading(false)
      }

    } catch (error) {
      console.error("Vendor ID could not be fetched:", error);
    }


  };




   useEffect(() => {
          if (location.state) {
            const { filter, month, year ,id} = location.state;
        
            if (filter && month && year && id) {
             setCompanyId(id)
             console.log('filter',filter)
             setLocationFilter(filter)
              setSelectedMonth(month);
              setSelectedYear(year);
               fetchEstablishment(id); // Optional
               fetchData(id,month, year);
            }
          }
          else {
          
              setSelectedMonth('');
              setSelectedYear('');
             setLocationFilter('')

            
            
            }
        }, [location.state]);
  
  useEffect(() => {
    if (location.state) {
      const { filter, month, year ,id} = location.state;
      if (  filter && month && year && id) {
         setCompanyId(id)
         setLocationFilter(filter)
        setSelectedMonth(month);
        setSelectedYear(year);
        fetchEstablishment(id);
        fetchData(id, month, year);
      }
      else{
        setLocationFilter('')
        setSelectedMonth('')
        setSelectedYear('')
      }
     
    }
  }, [location.state]);




  const fetchEstablishment = async (companyId) => {
    try {
        const response = await api.client.getClient(companyId);
        if(response.status === 200){
        const data = response.data.data;
        console.log(data,"data.lnegth")
        setEstablishment(data);
        setLoading(false)
      

        }
        else if(response.status === 400){
            setErrorSnackbarOpen(true);
            setSnackbarErrorMessage(response.data.message);
            setEstablishment([])
        }
        else if(response.status === 404){
            setErrorSnackbarOpen(true);
            setSnackbarErrorMessage(response.data.message);
            setEstablishment([])
            setLoading(false)
        }
        else if(response.status === 500){
            setErrorSnackbarOpen(true);
            setSnackbarErrorMessage(response.data.message);
            setEstablishment([])
            setLoading(false)
        }
        else{
            setErrorSnackbarOpen(true);
            setSnackbarErrorMessage("Some error occured, please try again")
            setEstablishment([])
            setLoading(false)
        }
    } catch (error) {
        console.error("Vendor ID could not be fetched:", error);
    }
};
  useEffect(() => {
    if (companyId && selectedMonth && selectedYear) {
      fetchData(companyId, selectedMonth, selectedYear);
    }
  }, [companyId, selectedMonth, selectedYear]);



 const fetchData = async (companyId, selectedMonth, selectedYear) => {
 
  try {
    const response = await api.client.getEstablishmentMonthlyData(companyId, selectedMonth, selectedYear);
    if(response.status===200){
    const data = response.data.data;

    const initialState = {};
    const initialSaveState = {};
     const initialPendingValidationState = {}; 
    titles.forEach(title => {
         const validation = data[title]?.validation;
      
      
      initialState[title] = {
        
        file: null,
        Category: data[title]?.Category || '',
        frequency: data[title]?.frequency || '',
        DueDate: hardcodedDueDates[title],
        fileUrl: data[title]?.fileUrl || '',
        uploaded: !!data[title]?.fileUrl,
        validation:validation,
        uploading: false,
        na: data[title]?.na || false,
        AssessorRemark: data[title]?.AssessorRemark || '',
        clientRemark: data[title]?.clientRemark || ''
      };
initialSaveState[title] = validation === 2 || validation === 3;
       if (validation === 2 || validation === 3) {
          initialPendingValidationState[title] = validation;
        }
      

});

      
    

    setUploadStates(initialState);
   setPendingValidation(initialPendingValidationState);
    setComplianceFiledDate(response.data.data.complianceFiledDate)
    setSaveStates(initialSaveState);
    
}
else if(response.status === 400){
                setErrorSnackbarOpen(true);
            setSnackbarErrorMessage(response.data.message);
    setUploadStates({});
    setComplianceFiledDate('')
    setSaveStates({});
setPendingValidation({});

}
else if(response.status === 404){
                setErrorSnackbarOpen(true);
            setSnackbarErrorMessage(response.data.message);
    setUploadStates({});
    setComplianceFiledDate('')
    setSaveStates({});
setPendingValidation({});


}
else if(response.status === 500){
                setErrorSnackbarOpen(true);
            setSnackbarErrorMessage(response.data.message);
    setUploadStates({});
    setComplianceFiledDate('')
    setSaveStates({});
setPendingValidation({});


}
else{
                setErrorSnackbarOpen(true);
            setSnackbarErrorMessage('some error occured!, please try again later');
}
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};

const handleViewDocument = (title,fileUrl,index) => {
     setOpenedDocs(prev => ({ ...prev, [title]: true }));

    window.open(`https://docs.google.com/gview?url=${fileUrl}&embedded=true`, '_blank')
  };







   const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === 'clientName') {

      api.client.getClients().then(response => {
        const selectedClient = response.data.find(client => client.companyId === value);
        if (selectedClient) {
          const { companyId, clientName } = selectedClient;

          setClientFormData(prevState => ({
            ...prevState,
            clientName,
            companyId,
          }));

          setCompanyId(companyId); 
  sessionStorage.setItem('selectedCompanyId',companyId)// set this first
        

        }

      })
        .catch(error => {
          console.error('Error fetching vendor details:', error);

        });
    }






    if (name !== 'clientName' && name !== 'assessorName') {
      setClientFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };


const handleSave = async (title, idx) => {
  const state = uploadStates[title];
  const validationValue = pendingValidation[title]; 

  if (!selectedMonth || !selectedYear) {
    setErrorSnackbarOpen(true)
    setSnackbarErrorMessage('Please select month and year')
    return;
  }

  if (validationValue !== 2 && validationValue !== 3) {
    setErrorSnackbarOpen(true);
    setSnackbarErrorMessage('Please Accept or Reject the document first.');
    return;
  }

  if (validationValue === 3 && !state.AssessorRemark?.trim()) {
    setErrorSnackbarOpen(true);
    setSnackbarErrorMessage('Assessor Remark is mandatory for rejection.');
    return;
  }

  const payload = {
    companyId,
    month: selectedMonth,
    year: selectedYear,
    [title]: {
      ...state,
      validation: validationValue,
    }
  };

  try {
    const response = await api.client.updateEstablishmentMonthlyData(payload);
    if (response.status === 200) {




      // ✅ Only now update saved validation
      setUploadStates(prev => ({
        ...prev,
        [title]: {
          ...prev[title],
          validation: validationValue
        }
      }));

      // Clear pending state
      setPendingValidation(prev => {
        const updated = { ...prev };
        delete updated[title];
        return updated;
      });

      setSaveStates(prev => ({ ...prev, [title]: true }));
      setSnackbarOpen(true);
      setSnackbarMessage('Saved successfully');
 try {
  const payload = {
    companyId,
    month:selectedMonth,
    year:selectedYear}
          // console.log('Calling assessorToMail with payload:', payload);
          const response = await api.assessor.fromAssessorMail(payload);

          if (response.status === 200) {
            setSnackbarOpen(true);
            setSnackbarMessage(response.data.message);
          }
          else if (response.status === 400) {
            setErrorSnackbarOpen(true);
            setSnackbarErrorMessage(response.data.message);
          }
          else if (response.status === 404) {
            setErrorSnackbarOpen(true);
            setSnackbarErrorMessage(response.data.message);
          }
          else if (response.status === 500) {
            setErrorSnackbarOpen(true);
            setSnackbarErrorMessage(response.data.message);
          } else {
            setErrorSnackbarOpen(true);
            setSnackbarErrorMessage(response.data.message);
          }
        } catch (emailErr) {
          console.error('assessorToMail error:', emailErr);
          setErrorSnackbarOpen(true);
          setSnackbarErrorMessage(emailErr?.response?.data?.message);
        }

    }
  } catch (err) {
    console.error(err);
  }
};


const openSuggestionMenu = (title) => (e) => {
  setActiveRemarkIndex(title);
  setMenuAnchorEl(e.currentTarget);
};

const closeSuggestionMenu = () => {
  setMenuAnchorEl(null);
  setActiveRemarkIndex(null);
};

const handleSuggestionSelect = (title, option) => {
  if (option === "Other") {
    // allow manual editing
    setEditableRemarks((prev) => ({ ...prev, [title]: true }));

    setUploadStates(prev => ({
      ...prev,
      [title]: {
        ...prev[title],
        AssessorRemark: ""   // clear for manual input
      }
    }));

    // enable save if validation is correct
    if (uploadStates[title]?.validation === 3) {
      setSaveStates(prev => ({ ...prev, [title]: false }));
    }
  } else {
    // lock editing & set suggestion text
    setEditableRemarks((prev) => ({ ...prev, [title]: false }));

    setUploadStates(prev => ({
      ...prev,
      [title]: {
        ...prev[title],
        AssessorRemark: option
      }
    }));

    // ✅ run save state check here also
    if (
      (uploadStates[title]?.validation === 3 && option.trim() !== "") ||
      uploadStates[title]?.validation === 2
    ) {
      setSaveStates(prev => ({ ...prev, [title]: false }));
    }
  }

  closeSuggestionMenu();
};

const getFilteredTitles = () => {
  if (!locationFilter || locationFilter === '') return titles;

  return titles.filter(title => {
    const savedValidation = uploadStates[title]?.validation;

    if (locationFilter === "underReview") return savedValidation === 1;
    if (locationFilter === "accepted") return savedValidation === 2;
    if (locationFilter === "rejected") return savedValidation === 3;

    return true;
  });
};





const handleValidationChange = (title, value, index, fileUrl) => {
  // Block if document not opened
  if (fileUrl && !openedDocs[title]) {
    setErrorSnackbarOpen(true);
    setSnackbarErrorMessage(
      "Please view the document before accepting or rejecting"
    );
    return;
  }

  // Store validation temporarily
  setPendingValidation(prev => ({
    ...prev,
    [title]: value
  }));

  // Accept → Autofill “Verified OK”
  if (value === 2) {
    setUploadStates(prev => ({
      ...prev,
      [title]: {
        ...prev[title],
        AssessorRemark: "Verified OK"
      }
    }));
  }

  // Reject → empty remark initially
  if (value === 3) {
    setUploadStates(prev => ({
      ...prev,
      [title]: {
        ...prev[title],
        AssessorRemark: ""
      }
    }));
  }

  // Enable Save button
  setSaveStates(prev => ({
    ...prev,
    [title]: false
  }));
};





 const renderDropdowns = () => {
    if (userType === 'admin') {
      return (



        <div className="mt-2 mb-3 mx-2 d-flex gap-2 justify-content-end">

          <Select value={clientFormData.companyId} onChange={handleChange} name="clientName" displayEmpty
            style={{ height: "35px", minWidth: '250px', maxWidth: '300px' }}>
            <MenuItem value="" disabled>Select Establishment</MenuItem>
            {Array.isArray(clients) && clients.map((client, index) => (
              <MenuItem key={client.companyId} value={client.companyId}>
                {client.clientName}, {client.stateId}
              </MenuItem>
            ))}
          </Select>
           
        <select style={{border:'1px solid lightgray',borderRadius:'5px'}} className='p-1' value={selectedMonth || ''}
         onChange={(e) => {
          setSelectedMonth(e.target.value)
          setLocationFilter('')
          
        }}>
          <option value="" disabled>Select Month</option>
          {months.map((month) => (
            <option key={month.value} value={month.value}>{month.name}</option>
          ))}
        </select>
        <select style={{border:'1px solid lightgray',borderRadius:'5px'}} className='p-1' value={selectedYear || ''} 
        onChange={(e) => {
          setSelectedYear(e.target.value)
          setLocationFilter('')
        
          }}>
          <option value="" disabled>Select Year</option>
          {years.map((year) => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>
       
      </div>
        

      );
    } else if(userType === 'assessor'){
      return (
         <div className="mb-3 d-flex float-end">
        <select style={{border:'1px solid lightgray',borderRadius:'5px'}} className='mx-1 p-1' value={selectedMonth || ''}
         onChange={(e) => {
         setSelectedMonth(e.target.value)
         setLocationFilter('')
         }}>
          <option value="" disabled>Select Month</option>
          {months.map((month) => (
            <option key={month.value} value={month.value}>{month.name}</option>
          ))}
        </select>
        <select style={{border:'1px solid lightgray',borderRadius:'5px'}} className='mx-1 p-1' value={selectedYear || ''} 
        onChange={(e) => {
          setSelectedYear(e.target.value)
          setLocationFilter('')

        }}>
          <option value="" disabled>Select Year</option>
          {years.map((year) => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>
       
      </div>
      );
    }
  };





  return (
    <>
     {loading ? (
            <div className="d-flex flex-row align-items-center justify-content-center" style={{ marginTop: '80px' }}>
            <h3>Loading</h3>
      <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div> 
      <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div>
      <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div>
      
      </div>
             ) : (
                <section>
     <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
     
                    }}
                    severity="success"
                    open={snackbarOpen}
                    autoHideDuration={4000}
                    onClose={() => setSnackbarOpen(false)}
                    sx={{
                        marginTop: '2.9%',
                        marginRight: '7%'
                    }}
                >
                    <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
                </Snackbar>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    severity="error"
                    open={errorSnackbarOpen}
                    autoHideDuration={5000}
                    sx={{
                        marginTop: '2.9%',
                        marginRight: '7%'
                    }}
                    onClose={() => { setErrorSnackbarOpen(false) }}
                >
                    <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
                </Snackbar>
    <div className="d-grid">
        <div className='mx-4'>
          <div className='d-flex pb-3' style={{ justifyContent: 'space-between'}}>
                        <div className="mt-3" style={{ letterSpacing: '1px' }}>
                            <div style={{ backgroundColor: COLORS.bggray, width: '15px', height: '15px', display: 'inline-block', marginRight: '4px', marginLeft: '8px', borderRadius: '50%' }}></div>
                            <span style={{ fontSize: '14px' }}>Under review</span>
                            <div className="vr  mx-3"></div>
                            <div style={{ backgroundColor: COLORS.success, width: '15px', height: '15px', display: 'inline-block', marginRight: '4px', borderRadius: '50%' }}></div>
                            <span style={{ fontSize: '14px' }}>Accepted</span>
                            <div className="vr mx-3"></div>
                            <div style={{ backgroundColor: COLORS.danger, width: '15px', height: '15px', display: 'inline-block', marginRight: '4px', borderRadius: '50%' }}></div>
                            <span style={{ fontSize: '14px' }}>Rejected</span>
                        </div>
                        </div>
                        <div>
         {renderDropdowns()} 
        </div>            
    
</div>
      <div style={{ minHeight:'370px',maxHeight: "380px",overflowY: "auto" }}>
      <table className="mt-0 pt-0" >
      
        <thead className='position-sticky top-0' style={{ zIndex: 10 }}>
          <tr className='text-white bg-dark'>
            <th>Name of DOC</th>
            <th>Category</th>

            <th>Frequency</th>
            <th>Due Date</th>
            <th>Uploaded File</th>
          <th>Actions</th>
            <th>Observation</th>
          
              <th>Action</th>
          </tr>
        </thead>
        <tbody>
            
              {complianceFiledDate && (
                          <section className='p-3'>
                <div>
              {complianceFiledDate ? `Compliance Filed Date: ${complianceFiledDate.slice(0, 10).split('-').reverse().join('-')}` : ""}
            </div>
            <div>
            <button className='flex flex-row items-center gap-1 text-sm text-danger' onClick={handleShow}>
                   <MdFileOpen className="text-xl text-danger" /> View Report
                </button>
                </div> 
                </section>     
            )}
            
          {getFilteredTitles().map((title, idx) => {
            const state = uploadStates?.[title] || {};
         
            return (
           <tr
  key={idx}
style={{
    backgroundColor:
      pendingValidation[title] === 2
        ? 'lightgreen'
        : pendingValidation[title] === 3
        ? 'lightcoral'
        : uploadStates[title]?.validation === 1
        ? COLORS.bggray
        : uploadStates[title]?.validation === 2
        ? 'lightgreen'
        : uploadStates[title]?.validation === 3
        ? 'lightcoral'
        : 'transparent'
  }}
>

                {/* <td>{title}</td> */}
                <td>{formatTitle(title)}</td>
                <td className='text-secondary'>{state?.Category}</td>

                <td>{state.frequency || ''}</td>
                <td>{state.DueDate || '-'}</td>
                {/* <td >{typeof state.DueDate === 'object' ? state.DueDate?.value : state.DueDate || ''}</td> */}
               <td>
  <div className="d-flex justify-content-between align-items-center">
    {state.na ? (
      <p className="mb-0">Not Applicable</p>
    ) : (
      <>
        {state.fileUrl && (
          <div className="d-flex gap-3 align-items-center">
            <button
              className="flex flex-col items-center text-sm text-green-700 border-0 bg-transparent"
              onClick={() => handleViewDocument(title,state.fileUrl,idx)}
            >
              <MdFileOpen className="text-xl text-success" />
              View
            </button>
            <a download
              className="flex flex-col items-center text-sm text-blue-700 border-0 bg-transparent"
              href={state.fileUrl}
            >
              <FaFileDownload className="text-xl text-primary" />
              Download
            </a>
          </div>
        )}
      </>
    )}
  </div>
</td>
               <td>
                <div className="flex gap-3">
      <label className="flex items-center gap-1">
        <input
          type="radio"
        
         checked={
  pendingValidation[title] === 2 ||
  (pendingValidation[title] === undefined && uploadStates[title]?.validation === 2)
}

          onChange={() => handleValidationChange(title, 2,idx,state.fileUrl)}
        />
        Accept
      </label>

      <label className="flex items-center gap-1">
        <input
          type="radio"
         
         checked={
  pendingValidation[title] === 3 ||
  (pendingValidation[title] === undefined && uploadStates[title]?.validation === 3)
}

          onChange={() => handleValidationChange(title, 3,idx,state.fileUrl)}
        />
        Reject
      </label>
    </div>
          </td>
        
                <td >
                   <div style={{ position: 'relative' }}>
  <textarea
  rows="3"
  type="text"
  readOnly={!editableRemarks[title]}
  placeholder="Enter your remarks here"
  className="p-2 border border-secondary w-full"
  value={uploadStates[title]?.AssessorRemark || ""}
  onChange={(e) => {
    const newRemark = e.target.value;

    // Update remarks safely
    setUploadStates(prev => ({
      ...prev,
      [title]: {
        ...prev[title],
        AssessorRemark: newRemark
      }
    }));

    // Enable Save based on validation
    setSaveStates(prev => {
      const validation = pendingValidation[title]; // 2=accept, 3=reject

      // Accept → Save always enabled
      if (validation === 2) {
        return { ...prev, [title]: false };
      }

      // Reject → Save only if remark entered
      if (validation === 3 && newRemark.trim() !== "") {
        return { ...prev, [title]: false };
      }

      return prev;
    });
  }}
/>


                               <button
      type="button"
      onClick={openSuggestionMenu(title)}
      style={{
        position: 'absolute',
        right: 10,
        bottom: 8,
        fontSize: 15,
        color: 'blue',
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: 0,
      }}
    >
         <ArrowDropDownIcon/>
    
    </button>
    </div>
  {state.clientRemark && (
                        <div className="p-1" style={{ overflow: 'auto', width: '400px', height: '80px', border: '1px solid lightgray', color: 'red' }}>
                          Establishment remark: {state.clientRemark}
                        </div>
                      )}

                </td>
                
             <td>
<button
 disabled={
  saveStates[title] ||
  !(pendingValidation[title] === 2 || pendingValidation[title] === 3) ||
  (pendingValidation[title] === 3 && (state.AssessorRemark || '').trim() === '')
}

  onClick={() => handleSave(title)}
  className='btn btn-outline-dark btn-md'
>
  {saveStates[title] ? 'Saved' : 'Save'}
</button>


{(() => {
  // get current validation value (2 = accepted, 3 = rejected)
  const validation =
  pendingValidation[title] !== undefined
    ? pendingValidation[title]
    : uploadStates[title]?.validation;

  let filteredSuggestions = suggestionOptions;

  if (validation === 2) {
    // ✅ accepted → show only Verified Ok and Other
    filteredSuggestions = ["Verified Ok", "Other"];
  } else if (validation === 3) {
    // ❌ rejected → show all except Verified Ok
    filteredSuggestions = suggestionOptions.filter(opt => opt !== "Verified Ok");
  }

  return (
    <Menu
      anchorEl={menuAnchorEl}
      open={activeRemarkIndex === title}
      onClose={closeSuggestionMenu}
    >
      {filteredSuggestions.map((opt) => (
        <MenuItem
          key={opt}
          onClick={() => handleSuggestionSelect(title, opt)}
          style={{ fontSize: "13px", padding: "4px 12px" }}
        >
          {opt}
        </MenuItem>
      ))}
    </Menu>
  );
})()}


</td>



              </tr>
            );
          })}
        </tbody>
      </table>
      </div>
    {companyId && (
 <ClientMonthlyReport showModal={showModal} onClose={handleClose}   selectedMonth={selectedMonth} 
  selectedYear={selectedYear} />)}


     
    </div>
      </section>
     )}
    </>
  );
};

export default MonthlydataEstablishment;
